import { render } from "./ViewRegisteredStudent.vue?vue&type=template&id=0af5ac17"
import script from "./ViewRegisteredStudent.vue?vue&type=script&lang=js"
export * from "./ViewRegisteredStudent.vue?vue&type=script&lang=js"
script.render = render

export default script